import React from "react";
import { toast } from "react-toastify";

import { getResponses } from "../utils/backend";
import {
  copyToClipboard,
  getFormUrl,
  formatTitle,
  downloadResponses,
} from "../utils/helpers";

const FormsListItem = ({ form }) => {
  const { formId, title } = form;

  const onShareFormLinkClicked = () => {
    copyToClipboard(getFormUrl(formId));
    toast.info("Form link copied to clipboard");
  };

  const onDownloadResponsesClicked = async () => {
    toast.info(
      "Please wait while all the responses of this form are retrieved"
    );

    const responses = await getResponses(formId);

    // check if response empty
    if (responses.length > 0) {
      downloadResponses(responses, title);
      toast.success("Downloading...");
      toast.info("Links to the attachments are valid only for 1 hour.");
    } else {
      toast.warn("No response submitted yet");
    }
  };

  return (
    <li className="list-group-item py-3 d-flex align-items-center">
      <h6>{formatTitle(title)}</h6>
      <div className="ml-auto d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-outline-primary mr-4"
          onClick={onShareFormLinkClicked}
        >
          Share Form Link
        </button>
        <button
          type="button"
          className="btn btn-outline-success"
          onClick={onDownloadResponsesClicked}
        >
          Download Responses
        </button>
      </div>
    </li>
  );
};

export default FormsListItem;
